import { Component, Inject, Input, OnInit } from '@angular/core';
import { ObjetivosAreaJardinModel } from 'src/app/model/FaseEstrategica.model';
import { FaseEstrategicaComponent } from '../fase-estrategica.component';

@Component({
  selector: 'app-objetivos-estrategicos-fe',
  templateUrl: './objetivos-estrategicos-fe.component.html',
  styleUrls: ['./objetivos-estrategicos-fe.component.css']
})
export class ObjetivosEstrategicosFEComponent implements OnInit {

  @Input() indice : number;
  @Input() objetivoArea : ObjetivosAreaJardinModel;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() simulacion: boolean;
  
  objetivosAreaJardin = new ObjetivosAreaJardinModel();

  constructor(
    @Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
  ) { }

  ngOnInit(): void {  

  }


  change(){
    this.parentFE.cambios = true;
  }
}
